import { cx } from 'utils/cx'

import text from 'fukku/styles/texts.module.scss'
import styles from './StoreAddress.module.scss'

export function Collections({
	collections,
}: {
	readonly collections: string[]
}): React.ReactNode {
	if (collections.length === 0) {
		return null
	}

	return (
		<p
			data-testid='maps.address.store.collections'
			className={cx(styles.collections, text.uppercaseM, styles.noMargin)}
		>
			{collections.join(', ')}
		</p>
	)
}
